import { StoreProfileEnum } from './enums';
import { IStoreState } from './types';

export const storesFilterInitialState = {
  searchStore: '',
  page: 0,
  rowsPerPage: 20,
};

export const storesInitialState: IStoreState = {
  storeSelected: {
    storeUserId: '',
    name: '',
  },
  storeLogged: {
    id: '',
    name: '',
    storeUserId: '',
    address: {
      postalCode: '',
      city: '',
      state: '',
      street: '',
      number: '',
      neighborhood: '',
    },
    checked: false,
    profileId: '',
    group: StoreProfileEnum.EMPTY,
    storeGroupId: '',
  },
  storeList: [
    {
      id: '',
      name: '',
      cnpj: '',
      address: {
        city: '',
        state: '',
        street: '',
        number: '',
        neighborhood: '',
        postalCode: '',
      },
    },
  ],
  storesFilter: storesFilterInitialState,
  stores: {
    count: 0,
    items: [],
  },
  storeGroup: {
    storeGroupList: [
      {
        id: '',
        name: '',
      },
    ],
    storeGroupSelected: {
      id: '',
      name: '',
    },
  },
};
